import { useState } from "react";
import whatsapp from "../../../Images/whatsapp.png";
import "../Memberownprofile.css";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import blankpro from "../../../Images/blank.jpg";
import pdf from "../../../Images/pdf.png";
import QRshareModal from "../../../Modal/QRshareModal";
import ProfileShare from "../../../Modal/ProfileShare";
import HttpClient from "../../../utils/HttpClient";
import { useEffect } from "react";
import ReactPlayer from "react-player";
import { useDispatch, useSelector } from "react-redux";
import {
    ShareModalonOff,
    getOwnProfile,
    getPosts,
} from "../../../Redux/Slice/PostSlice";
import verified from "../../../Images/Verify responsive.png";
import StarRatings from "react-star-ratings";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {
    onDisconnect,
    ref,
    set,
    update,
    get,
} from "firebase/database";
import { db } from "../../../Firebase/FirebaseConfig";
import { OnetoOneChatIdname } from "../../../Redux/Slice/Chat";
import moment from "moment";
import Messageicon from "../../../Images/Message-icon.png";
import editicon from "../../../Images/editicon.png";
import photoEditIcon from "../../../Images/photo-edit-icon.png";
import call from "../../../Images/Call.png";
import toast from "react-hot-toast";
import MemberProfileEditModal from "../../../Modal/MemberProfileEditModal";
import MemberImageEditModal from "../../../Modal/MemberImageEditModal";
import { openCallAppLink, openWhatsAppLink, openWindow } from "../../../Component/OpenWhatsApp";

//Icons
import callIcon from "../../../Images/svg/Call.svg";
import mobileIcon from "../../../Images/svg/Mobile.svg";
import whatsappIcon from "../../../Images/svg/WP.svg";
import emailIcon from "../../../Images/svg/Email.svg";
import websiteIcon from "../../../Images/svg/Web.svg";
import locationIcon from "../../../Images/svg/Location.svg";
import likeThumbIcon from "../../../Images/like/like-c.png";
import tticon from "../../../Images/taptorate.png";
import GiveRattingModal from "../../../Modal/GiveRattingModal";
import NeoCardLink from "../components/NeoCardLink";
import RewardPoints from "../../../utils/RewardPoints";
import ProductViewModal from "../../../Modal/ProductViewModal";
import CompanyInfoUpdateModal from "../../../Modal/CompanyInfoUpdateModal";
import ProfileSkeletonNonMemUser from "../../../Modal/skeleton/ProfileSkeletonNonMemUser";
import MemberInfoUpdateModal from "../../../Modal/MemberInfoUpdateModal";
import MemberBannerProfileUpdate from "../../../Modal/MemberBannerProfileUpdate";
import MemberVideoDocumentUpdateModal from "../../../Modal/MemberVideoDocumentUpdateModal";
import MemberProductsUpdateModal from "../../../Modal/MemberProductsUpdateModal";
import MyProfileAboutModal from "../../../Modal/MyProfileAboutModal";
import MyProfileServices from "./MyProfileServices";
import AddMyProfileServiceModal from "../../../Modal/AddMyProfileServiceModal";
import MemberVideoUpdateModal from "../../../Modal/MemberVideoUpdateModal";

const MemberProfile = () => {
    const params = useParams()
    const [hasUnreadMessages, setHasUnreadMessages] = useState(false);
    const [UserMemberData, setUserMemberData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [contactdetail, setContactdetail] = useState(true);
    const [aboutdetail, setAboutdetail] = useState(true);
    const [servicedetail, setServicedetail] = useState(true);
    const [productdetail, setProductdetail] = useState(true);
    const [servicepdfdetail, setServicepdfdetail] = useState(true);
    const [modala, setModala] = useState(false);
    const [showmodal, setShowmodal] = useState(false);
    const [sharemodal, setSharemodal] = useState(false);
    const [ProductItem, setProductItem] = useState("");
    const [savedContacts, setsavedContacts] = useState([]);
    const [countDown, setCountDown] = useState();
    const [show, setShow] = useState(false)

    const {
        ShareModalOpenClose,
        UserProfileID,
    } = useSelector((state) => state.app);

    const [data, setData] = useState();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handledetailClick = () => {
        setContactdetail(!contactdetail);
    };

    const handleaboutClick = () => {
        setAboutdetail(!aboutdetail);
    };

    const handleserviceClick = () => {
        setServicedetail(!servicedetail);
    };

    const handleproductClick = () => {
        setProductdetail(!productdetail);
    };

    const handleservicepdfClick = () => {
        setServicepdfdetail(!servicepdfdetail);
    };

    const handlemodalClick = async (item) => {
        setModala(!modala);
        setProductItem(item);
        await addRewardPoints(data?._id, RewardPoints.PRODUCT_VIEW_TYPE);
    };

    const modhandleclick = () => {
        setShowmodal(!showmodal);
    };

    const shareClick = () => {
        setSharemodal(!sharemodal);
        dispatch(ShareModalonOff(true));
    };

    const [connectSent, setConnectSent] = useState(false)
    const getUserProfileByParam = async (id) => {
        const res = await HttpClient.requestData(`single-user-by-username/${id}`, "GET", {});
        if (res && res?.status) {
            setConnectSent(res?.data?.isConnectRequestSent)
            setVisitingProfileID(res?.data?._id)
            setUserMemberData(res?.data);
            setData(res?.data);
            await generateCard(res?.data?._id);
        }
    };

    const chkChatlistAndCreate = () => {
        dispatch(OnetoOneChatIdname(data?._id));
        navigate("/chat");
    };

    const savedContactList = async () => {
        const res = await HttpClient.requestData(
            "get-userby-key-nonMem",
            "POST",
            { key: "all" }
        );
        if (res && res?.status) {
            setsavedContacts(res?.data[0]);
        }
    };

    const [visitingProfileID, setVisitingProfileID] = useState("")
    const handleProfileVisit = async () => {
        try {
            await HttpClient.requestData(`business-profile-visit`, "POST", { userId: visitingProfileID });
        } catch (error) {

        }
    }

    useEffect(() => {
        visitingProfileID && visitingProfileID !== UserProfileID?._id && handleProfileVisit()
    }, [visitingProfileID])

    const updateForm = (key, value) => {
        setData((prev) => ({ ...prev, [key]: value }));
    };

    useEffect(() => {
        const checkForUnreadMessages = async () => {
            try {
                if (!db || typeof db !== "object") {
                    throw new Error(
                        "Realtime Database instance is not properly initialized"
                    );
                }
                const chatListRef = ref(db, `chatList/${UserProfileID?._id}`);
                get(chatListRef)
                    .then((snapshot) => {
                        let countData = Object.values(snapshot.val()).reduce(
                            (prev, current) => {
                                let count = current.seenCount ?? 0;
                                return prev + count;
                            },
                            0
                        );
                        setCountDown(countData);
                    })
                    .catch((error) => {
                        // console.log("error", error);
                    });
            } catch (error) {
                console.error("Error checking for unread messages:", error);
            }
        };

        if (UserProfileID?._id) {
            checkForUnreadMessages();
        }
    }, [UserProfileID, db]);

    useEffect(() => {
        savedContactList();
        params.name === "business-user" ? setData(UserProfileID) : getUserProfileByParam(params.name)
        params.name === "business-user" && generateCard(UserProfileID?._id);
    }, [params.name]);

    useEffect(() => {
        dispatch(getPosts());
        dispatch(OnetoOneChatIdname(""));
        dispatch(getOwnProfile());
    }, []);

    useEffect(() => {
        if (UserProfileID) {
            const userId = UserProfileID?._id;

            const userData = {
                personName: UserProfileID?.personName,
                username: UserProfileID?.userName || "",
                email: UserProfileID?.emailId,
                profile_picture: UserProfileID?.profilePhoto || "",
                status: "online",
                blockedUsers: [],
            };

            if (userId) {
                const userRef = ref(db, "users/" + userId);
                const userStatusRef = ref(db, "status/" + userId);

                // Set user data in the database
                set(userRef, userData)
                    .then(() => console.log("User data set successfully"))
                    .catch((error) => console.log(error));

                // Handle online/offline status
                const isOfflineForDatabase = {
                    state: "offline",
                    last_changed: moment(Date.now()).format("MMMM DD, YYYY"),
                    last_seen_time: moment(Date.now()).format("HH:mm"),
                };
                const isOnlineForDatabase = {
                    state: "online",
                    last_changed: moment(Date.now()).format("MMMM DD, YYYY"),
                    last_seen_time: moment(Date.now()).format("HH:mm"),
                };

                // Set online status
                set(userStatusRef, isOnlineForDatabase);

                // Set up onDisconnect to set offline status
                onDisconnect(userStatusRef).set(isOfflineForDatabase);

                // Update last seen time when the user goes offline
                window.addEventListener("beforeunload", () => {
                    update(userStatusRef, isOfflineForDatabase)
                        .then(() => console.log("Status updated to offline"))
                        .catch((error) => console.error("Error updating status:", error));
                });

            } else {
                console.log("UserProfileID does not have _id property");
            }
        } else {
            console.log("UserProfileID is undefined");
        }
        //After login
        params.name === "business-user" && setData(UserProfileID)
    }, [UserProfileID]);

    // update popup start
    const [isPopupOpen, setPopupOpen] = useState(false);
    const openPopup = async () => {
        const res = await HttpClient.requestData("request-upgrade", "GET", {});
        if (res && res?.status) {
            toast.success(res?.msg);

            setPopupOpen(!isPopupOpen);
        } else {
            toast.error(<>{res?.msg} <br /> Admin will contact you shortly</>);
        }
    };

    const [contactEditModal, setContactEditModal] = useState(false);
    const handleContactModalClick = () => setContactEditModal(!contactEditModal);

    useEffect(() => {
        saveEditedData && updateData(data);
    }, [data])

    const updateData = async (data) => {
        setIsLoading(true);
        try {
            if (data?.memberStatus) {
                const filteredFormData = {
                    id: data?._id,
                    companyName: data?.companyName,
                    designationID: data?.designationID,
                    companyTypeID: data?.companyTypeID,
                    phone_code: data?.phone_code,
                    telephoneNo: data?.telephoneNo,
                    mobileNo: data?.mobileNo,
                    whats_code: data?.whats_code,
                    whatsappNo: data?.whatsappNo,
                    websiteLink: data?.websiteLink,
                    address: data?.address,
                    locationLink: data?.locationLink,
                    country: data?.country,
                    countryName: data?.countryName,
                    emirate: data?.emirate,
                    facebookLink: data?.facebookLink,
                    linkedInLink: data?.linkedInLink,
                    instaLink: data?.instaLink,
                    neooBusinessPageLink: data?.neooBusinessPageLink,
                    youtubeLink: data?.youtubeLink,
                    banner: data?.banner,
                    profilePhoto: data?.profilePhoto,
                    videoUrl: data?.videoUrl,
                    doc: data?.doc,
                    productData: data?.productData,
                    companyDescription: data?.companyDescription,
                    serviceName: data?.serviceName,
                    serviceID: data?.serviceID
                };
                await updateProfileDetails(filteredFormData);
            } else {
                const updatedBusinessData = { ...data };
                const { _id, emailId, userName, passwordView, profilePhoto, TypeOfCompany, companyName, companyTypeID, country, designation, designationID, emirate, mobileNo, personName, phone_code, profileTypeID, telephoneNo, websiteLink, whats_code, whatsappNo, facebookLink, linkedInLink, instaLink, youtubeLink, userLink, address, twitterURL, locationLink, neooBusinessPageLink, ...rest } = updatedBusinessData;
                const filteredFormData = {
                    id: _id,
                    emailId, userName,
                    password: passwordView,
                    personName, profilePhoto,
                    country, emirate, mobileNo,
                    phone_code, telephoneNo,
                    websiteLink, whats_code,
                    whatsappNo, facebookLink,
                    linkedInLink, instaLink,
                    youtubeLink, userLink,
                    address,
                    twitterURL,
                    locationLink,
                    profileTypeID,
                    neooBusinessPageLink,
                    companyName,
                    designationID,
                    companyTypeID
                };
                const submitFormData = Object.entries(filteredFormData).reduce((acc,
                    [key, value]) => {
                    if (value !== undefined) {
                        acc[key] = value;
                    }
                    return acc;
                }, {});

                // const response = await HttpClient.requestData(`add-non-member`, "POST", submitFormData);
                const response = await HttpClient.requestData(`update-profile-info`, "PUT", submitFormData);
                if (response?.status) {
                    dispatch(getOwnProfile())
                    toast.success("Updated Successfully!")
                    setSaveEditedData(false);
                    getUserProfileByParam(params.name);
                }
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
        } finally {
        }
    }

    const [url, setUrl] = useState(data?.profilePhoto || "");
    const [editlogomaodalaa, setEditlogomaodalaa] = useState(false);
    const editlogoclickspcl = () => {
        setEditlogomaodalaa(!editlogomaodalaa);
    };

    const [saveEditedData, setSaveEditedData] = useState(false)
    const handleSaveAccountNonmember = async () => {
        const formData = {
            nonMemberId: data?._id,
        };
        const res = await HttpClient.requestData("send-req-connection", "POST", formData);
        if (res && res?.status) {
            // setShowPopup(!showPopup);
            getUserProfileByParam(params.name)
            toast.success("Request sent successfully");
        } else {
            toast.error("Contact Saving failed");
        }
    };

    const [tempLiked, setTempLiked] = useState(false)
    const handleNonmemberLike = async () => {
        const formData = {
            id: data?._id,
        };

        const res = await HttpClient.requestData("give-like", "POST", formData);
        if (res && res?.status) {
            setData({
                ...data,
                likeCount: data?.likeCount + 1
            })
            setTempLiked(true)
            toast.success("Profile liked successfully");
        } else {
            toast.error("Error occured");
        }
    };

    // const [copied, setCopied] = useState(false);
    // const textToCopy = data?.userLink
    const [pendingInvitation, setPendingInvitation] = useState()
    const getPendingInvitations = async () => {
        const res = await HttpClient.requestData("pending-directory", "GET", {});
        if (res && res?.status) {
            const match = res?.data.find(
                (item) => item?.connectionSendorId === data?._id
            );
            setPendingInvitation(match)
        }
    };

    const [mySavedContact, setMySavedContact] = useState()
    const getDirecoryContacts = async () => {
        const res = await HttpClient.requestData("get-userby-key", "POST", { key: "all" });
        if (res && res?.status) {
            const match = res?.data.find(
                (item) => item?.nonmemberDetails?._id === data?._id
            );
            setMySavedContact(match)
        }
    };

    useEffect(() => {
        getPendingInvitations()
        getDirecoryContacts()
    }, [params.name, data])

    //Accept connection request
    const handleAcceptConnectionRequest = async (e, notificationId, senderId) => {
        e.preventDefault()
        const formData = {
            nonMemberId: senderId,
            connectionId: notificationId,
            acceptStatus: "Accept"
        };

        const res = await HttpClient.requestData(
            "save-nonmember-contacts",
            "POST",
            formData
        );
        if (res && res?.status) {
            getPendingInvitations()
            getUserProfileByParam(params.name)
            toast.success("Request accepted successfully");
        } else {
            toast.error("Error occured");
        }
    };

    const handleClickOutside = () => {
        if (show == true) {
            setShow(false)
        }
    };

    const [giveratting, setGiveratting] = useState(false);
    const popupclick = () => {
        setGiveratting(!giveratting);
    };

    document.body.addEventListener('mousedown', handleClickOutside);

    const handleWhatsAppClick = async (e, whatsAppCode, whatsAppNo, id) => {
        e.preventDefault();
        if (!whatsAppCode || !whatsAppNo) {
            return;
        }
        await addRewardPoints(id, RewardPoints.WHATSAPP_CONTACT_TYPE);
        openWhatsAppLink(e, `${whatsAppCode}${whatsAppNo}`, "I got your contact from Neoo Search and interested in your profile")
    };

    const handlePhoneCallClick = async (e, phoneCode, phNumber, id) => {
        e.preventDefault();
        if (!phoneCode || !phNumber) {
            return;
        }
        await addRewardPoints(id, RewardPoints.CALL_TYPE);
        openCallAppLink(e, `${phoneCode}${phNumber}`)
    };

    const handleLinkClick = async (e, link, id, visitType, subType = '') => {
        if (e && typeof e.preventDefault === "function") {
            e.preventDefault();
        }

        if (!link) return;

        const normalize = (l) => {
            let u = String(l).trim();
            if (!/^https?:\/\//i.test(u)) u = `https://${u}`;
            return encodeURI(u);
        };

        try {
            await addRewardPoints(id, visitType, subType);
            openWindow(normalize(link));
        } catch (err) {
            console.error("Error opening website link:", err);
        }
    };

    const addRewardPoints = async (id, visitType, subType = '') => {
        return await HttpClient.requestData("getting-rewards", "POST", { profileId: id, type: visitType, subType });
    }

    const generateCard = async (userId) => {
        const payload = { id: userId };
        const response = await HttpClient.requestData("generate-card", "POST", payload);
        if (response?.status) {
            console.log("Card generated successfully");
        }
    }

    const [companyInfoUpdateModal, setCompanyInfoUpdateModal] = useState(false);
    const handleCompanyInfoUpdateModalClick = () => setCompanyInfoUpdateModal(!companyInfoUpdateModal);

    const [memberInfoUpdateModal, setMemberInfoUpdateModal] = useState(false);
    const handleMemberInfoUpdateModalClick = () => setMemberInfoUpdateModal(!memberInfoUpdateModal);

    const updateProfileDetails = async (data) => {
        try {
            const response = await HttpClient.requestData("update-profile-info", "PUT", data);
            if (response?.status) {
                dispatch(getOwnProfile())
                toast.success("Profile updated successfully");
                setSaveEditedData(false);
                getUserProfileByParam(params.name);
            }
        } catch (error) {
            console.error("Error updating profile details:", error);
        }
    }

    const [showEditBannerModal, setShowEditBannerModal] = useState(false);
    const editBannerModalClick = () => {
        setShowEditBannerModal(!showEditBannerModal);
    };

    const [memberVideoDocModal, setMemberVideoDocModal] = useState(false);
    const handleMemberVideoDocUpdateModalClick = () => setMemberVideoDocModal(!memberVideoDocModal);

    const [memberProductsModal, setMemberProductsModal] = useState(false);
    const handleMemberProductUpdateModalClick = () => setMemberProductsModal(!memberProductsModal);

    const [memberAboutUsModal, setMemberAboutUsModal] = useState(false);
    const handleMemberAboutUsModalClick = () => setMemberAboutUsModal(!memberAboutUsModal);

    const [addMemberServicesModal, setAddMemberServicesModal] = useState(false);
    const handleAddServiceModalClick = () => setAddMemberServicesModal(!addMemberServicesModal);

    const [memberVideoModal, setMemberVideoModal] = useState(false);
    const handleMemberVideoUpdateModalClick = () => setMemberVideoModal(!memberVideoModal);

    return (
        <>
            <div className="memberownprfl">
                <div className="cust_container">
                    {isLoading ? (
                        <ProfileSkeletonNonMemUser />
                    ) : (
                        <>
                            {data && data?.memberStatus && (
                                <>
                                    <div className="bg-wht">
                                        <div className={data?.memberStatus ? "bggradient" : "bggradient-noimage"}>
                                            <img src={data?.banner} alt="Profile Banner" title="Profile Banner" />
                                            {UserProfileID?._id === data?._id &&
                                                <span className="edit-icon-gen">
                                                    <img src={editicon} alt="edit icon" onClick={editBannerModalClick} />
                                                </span>
                                            }
                                        </div>

                                        <div className="persondetailsdiv">
                                            <div className="img_profileflx">
                                                <div className="imgbrdr">
                                                    <img
                                                        src={data?.profilePhoto || blankpro}
                                                        alt="img"
                                                    />
                                                </div>
                                                {
                                                    UserProfileID?.userName === data?.userName &&
                                                    <div className="photo-edit-icon" onClick={editlogoclickspcl}>
                                                        <img src={photoEditIcon} alt="Edit Icon" title="Edit Icon" />
                                                    </div>
                                                }
                                                <div className="dtlsprflnmmph">
                                                    <div className="left">
                                                        <p className="profile-name-member">
                                                            {data?.personName || <Skeleton />}
                                                            {data?.memberStatus &&
                                                                <span className="Verified">
                                                                    <img
                                                                        src={verified || <Skeleton />}
                                                                        className="img-fluid"
                                                                        alt="icon"
                                                                        style={{ width: 25, height: 25, marginLeft: 10 }}
                                                                    />
                                                                </span>
                                                            }
                                                        </p>
                                                        <p className="prodtlmarkettxt">
                                                            {data?.designation || <Skeleton />}
                                                        </p>
                                                        <p className="prodtlmarkettxt mt-2 mb-2">
                                                            @{data?.userName || <Skeleton />}
                                                        </p>
                                                        <div className="likeCount_all">
                                                            <p className="text">
                                                                <strong>
                                                                    {data?.likeCount < 0 ? (
                                                                        <Skeleton />
                                                                    ) : (
                                                                        data?.likeCount
                                                                    )}
                                                                </strong>
                                                                <span>Likes</span>
                                                            </p>
                                                            <p className="text">
                                                                <strong>{data?.memberSave?.length}</strong>
                                                                <span>Connections</span>
                                                            </p>
                                                            <p className="text">
                                                                <i className="fa-solid fa-calendar-days mr-2"></i>
                                                                Joined <strong>{moment(data?.createdOn).format("MMM YYYY") || <Skeleton />}</strong>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="likespinerdivflx " style={{ marginRight: '25px' }}>
                                                {data?.memberStatus && mySavedContact ? (
                                                    <>
                                                        <button
                                                            type="button"
                                                            className="Messagebtn_"
                                                            onClick={chkChatlistAndCreate}
                                                            style={{ position: "relative" }}
                                                        >
                                                            <img
                                                                src={Messageicon}
                                                                className="img-fluid"
                                                                alt="Message icon"
                                                            />
                                                            Message
                                                            {hasUnreadMessages && (
                                                                <span className="green-dot-unread-message"></span>
                                                            )}
                                                            {countDown > 0 && (
                                                                <div className="countdown-circle">
                                                                    <p>{countDown}</p>
                                                                </div>
                                                            )}
                                                        </button>
                                                    </>
                                                ) : (
                                                    <>
                                                        {UserProfileID?.userName === params?.name && (
                                                            <>
                                                                <button
                                                                    type="button"
                                                                    className="Messagebtn_"
                                                                    onClick={chkChatlistAndCreate}
                                                                    style={{ position: "relative" }}
                                                                >
                                                                    <img
                                                                        src={Messageicon}
                                                                        className="img-fluid"
                                                                        alt="Message icon"
                                                                    />
                                                                    Message
                                                                    {hasUnreadMessages && (
                                                                        <span className="green-dot-unread-message"></span>
                                                                    )}
                                                                    {countDown > 0 && (
                                                                        <div className="countdown-circle">
                                                                            <p>{countDown}</p>
                                                                        </div>
                                                                    )}
                                                                </button>
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                                {
                                                    UserProfileID?.userName === params?.name ? (
                                                        <>
                                                            <Link className="shredivflx" onClick={shareClick}>
                                                                <span className="">Share</span>
                                                                <i className="fa-solid fa-share-from-square"></i>
                                                            </Link>
                                                        </>
                                                    ) : (
                                                        <>
                                                            {
                                                                mySavedContact && (
                                                                    <>
                                                                        <div className="d-flex" style={{ gap: "5px" }}>

                                                                            <Link className="whatsppimg"
                                                                                onClick={(e) => handleWhatsAppClick(e, data.whats_code, data.whatsappNo, data?._id)}
                                                                                style={{
                                                                                    margin: "0 auto",
                                                                                    color: "#fff",
                                                                                    pointerEvents: !data?.whats_code || !data?.whatsappNo ? "none" : "auto",
                                                                                    opacity: !data?.whats_code || !data?.whatsappNo ? 0.5 : 1
                                                                                }}
                                                                                title={!data?.whats_code || !data?.whatsappNo ? `WhatsApp number not available` : "Contact via WhatsApp"}
                                                                            >
                                                                                <img src={whatsapp} alt="..." />
                                                                            </Link>

                                                                            <Link className="callimg"
                                                                                onClick={(e) => handlePhoneCallClick(e, data.phone_code, data.mobileNo, data?._id)}
                                                                                style={{
                                                                                    margin: "0 auto",
                                                                                    color: "#fff",
                                                                                    pointerEvents: !data?.phone_code || !data?.mobileNo ? "none" : "auto",
                                                                                    opacity: !data?.phone_code || !data?.mobileNo ? 0.5 : 1
                                                                                }}
                                                                                title={!data?.phone_code && !data?.mobileNo ? `Phone number not available` : "Call via Phone"}
                                                                            >
                                                                                <img src={call} alt="..." />
                                                                            </Link>
                                                                        </div>

                                                                        {
                                                                            (data?.mylikesStatus || tempLiked) ? (
                                                                                <>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="likedfollowlike"
                                                                                    >
                                                                                        <i className="fa-solid fa-thumbs-up"></i>
                                                                                        Liked
                                                                                    </button>
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="likedfollowlike"

                                                                                        onClick={() => handleNonmemberLike()}
                                                                                    >
                                                                                        <img src={likeThumbIcon} alt="..." className="img-fluid" />
                                                                                        Like
                                                                                    </button>
                                                                                </>
                                                                            )
                                                                        }

                                                                    </>
                                                                )
                                                            }
                                                            {
                                                                pendingInvitation ? (
                                                                    <>
                                                                        <button
                                                                            type="button"
                                                                            className="savecontact_btn"
                                                                            accordion
                                                                            onClick={(e) => handleAcceptConnectionRequest(e, pendingInvitation?._id, pendingInvitation?.connectionSendorId, pendingInvitation?.userId)}
                                                                        >
                                                                            <i className="fa-solid fa-user-plus"></i>
                                                                            Accept
                                                                        </button>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        {
                                                                            mySavedContact === undefined && connectSent &&
                                                                            <>
                                                                                <button
                                                                                    type="button"
                                                                                    className="savecontact_btn"
                                                                                    disabled
                                                                                >
                                                                                    Connect Requested
                                                                                </button>
                                                                            </>
                                                                        }
                                                                    </>
                                                                )
                                                            }
                                                            {
                                                                mySavedContact === undefined && !pendingInvitation && !connectSent && UserProfileID?.userName && (
                                                                    <>
                                                                        <button
                                                                            type="button"
                                                                            className="savecontact_btn"
                                                                            accordion
                                                                            onClick={() => handleSaveAccountNonmember()}
                                                                        >
                                                                            <i className="fa-solid fa-user-plus"></i>
                                                                            Connect
                                                                        </button>
                                                                    </>
                                                                )
                                                            }
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                        <div className="infolabbrdr">
                                            <div className="infoflx justify-content-between">
                                                <div className="d-flex align-items-center justify-content-between infoflx_wrap" style={{ width: "100%" }}>
                                                    <div style={{
                                                        display: 'flex'
                                                    }}>
                                                        <div className="rctdivimg" onClick={modhandleclick}>
                                                            {data?.qrCode && !isLoading && (
                                                                <img src={data?.qrCode} alt="QR" />
                                                            )}
                                                        </div>
                                                        <div className="groupdiv">
                                                            <div>
                                                                <h4 className="ocentxt">
                                                                    {data?.companyName}
                                                                </h4>
                                                                <p className="pcndgtxt">
                                                                    {data?.TypeOfCompany}
                                                                </p>
                                                                <div className=" d-flex">
                                                                    <p className="dbytxtp mr-1">
                                                                        {data?.countryName ? `${data?.emirate}, ` : data?.emirate}
                                                                    </p>
                                                                    <p className="dbytxtp">{data?.countryName}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="_mainrattingarea _mainrattingarea5626">
                                                        <div className="rating_box">
                                                            <StarRatings
                                                                rating={data?.avgRating}
                                                                starRatedColor="#F3660B"
                                                                starEmptyColor="grey"
                                                                numberOfStars={5}
                                                                name="UserProfileRating"
                                                                starDimension="20px"
                                                                starSpacing="5px"
                                                                className="fa-solid fa-star "
                                                            />
                                                        </div>

                                                        {UserProfileID?.userName !== params?.name &&
                                                            <>
                                                                <div className="giveratting_btn"
                                                                    style={{ marginTop: "15px" }}
                                                                >
                                                                    <button className="btn"
                                                                        onClick={popupclick}
                                                                    >
                                                                        <img src={tticon} className="img-fluid" alt=".." />
                                                                        Tap to Rate
                                                                    </button>
                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="socialdivflx">
                                            <NeoCardLink data={data} />
                                            <a
                                                href="#"
                                                onClick={(e) => handleLinkClick(e, data?.facebookLink, data?._id, RewardPoints.SOCIAL_LINK_VISIT_TYPE, RewardPoints.SOCIAL_LINK_VISIT_TYPE_FB)}
                                                target="_blank"
                                                className="bgsocial"
                                            >
                                                <i className="fa-brands fa-facebook-f"></i>
                                            </a>
                                            <a
                                                href="#"
                                                onClick={(e) => handleLinkClick(e, data?.instaLink, data?._id, RewardPoints.SOCIAL_LINK_VISIT_TYPE, RewardPoints.SOCIAL_LINK_VISIT_TYPE_IG)}
                                                target="_blank"
                                                className="bgsocial"
                                            >
                                                <i className="fa-brands fa-instagram"></i>
                                            </a>
                                            <a
                                                href="#"
                                                onClick={(e) => handleLinkClick(e, data?.linkedInLink, data?._id, RewardPoints.SOCIAL_LINK_VISIT_TYPE, RewardPoints.SOCIAL_LINK_VISIT_TYPE_LI)}
                                                target="_blank"
                                                className="bgsocial"
                                            >
                                                <i className="fa-brands fa-linkedin-in"></i>
                                            </a>

                                            <a
                                                href="#"
                                                onClick={(e) => handleLinkClick(e, data?.youtubeLink, data?._id, RewardPoints.SOCIAL_LINK_VISIT_TYPE, RewardPoints.SOCIAL_LINK_VISIT_TYPE_YT)}
                                                target="_blank"
                                                className="bgsocial"
                                            >
                                                <i className="fa-brands fa-youtube"></i>
                                            </a>
                                            <a
                                                href="#"
                                                onClick={(e) => handleLinkClick(e, data?.websiteLink, data?._id, RewardPoints.WEBSITE_LINK_VISIT_TYPE)}
                                                target="_blank"
                                                className="bgsocial"
                                            >
                                                <i className="fa-solid fa-globe"></i>
                                            </a>
                                        </div>

                                        <div className="cntntbrdr">
                                            <div className="flxcntnt">
                                                <p className="cntncttxt">Contact Details
                                                    {UserProfileID?.userName === data?.userName &&
                                                        <div className="editeiconimg"
                                                            style={{
                                                                float: "right",
                                                                maxWidth: "25px",
                                                                height: "25px",
                                                                cursor: "pointer",
                                                                marginLeft: "10px"
                                                            }}
                                                            onClick={handleMemberInfoUpdateModalClick}
                                                        >
                                                            <img src={editicon} alt="edit icon" />
                                                        </div>
                                                    }
                                                </p>
                                                <div className="ArrwiconDiv" onClick={handledetailClick}>
                                                    <span
                                                        className={
                                                            contactdetail
                                                                ? "fa-solid fa-chevron-up"
                                                                : "fa-solid fa-chevron-down"
                                                        }
                                                    ></span>
                                                </div>
                                            </div>
                                            {contactdetail && (
                                                <div className="">
                                                    <div className="divcnctflx">
                                                        <div className="brdrdivdtls">

                                                            <span className="txtdtlmn"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={(e) => handlePhoneCallClick(e, data.phone_code, data.telephoneNo, data?._id)}
                                                            >
                                                                <img src={callIcon} className="contactIcon" />

                                                                {data?.phone_code}&nbsp;
                                                                {data?.telephoneNo || data?.telephoneNo}
                                                            </span>
                                                        </div>
                                                        <div className="brdrdivdtls">
                                                            <span className="txtdtlmn"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={(e) => handlePhoneCallClick(e, data.phone_code, data.mobileNo, data?._id)}
                                                            >
                                                                <img src={mobileIcon} className="contactIcon" />
                                                                {data?.phone_code}&nbsp;
                                                                {data?.mobileNo}
                                                            </span>
                                                        </div>
                                                        <div className="brdrdivdtls">
                                                            <span className="txtdtlmn"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={(e) => handleWhatsAppClick(e, data.whats_code, data.whatsappNo, data?._id)}
                                                            >
                                                                <img src={whatsappIcon} className="contactIcon" />
                                                                {data?.whats_code}&nbsp;
                                                                {data?.whatsappNo}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="dibmailflx">
                                                        <div className="envelopdiv">
                                                            <NavLink to={`mailto:${data?.emailId}`} className="txtdtlmn">
                                                                <img src={emailIcon} className="contactIcon" />
                                                                {data?.emailId}
                                                            </NavLink>
                                                        </div>
                                                        <div className="envelopdiv">
                                                            <span className="txtdtlmn"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={(e) => handleLinkClick(e, data?.websiteLink, data?._id, RewardPoints.WEBSITE_LINK_VISIT_TYPE)}
                                                            >
                                                                <img src={websiteIcon} className="contactIcon" />
                                                                {data?.websiteLink}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="divloctin">
                                                        <span className="txtdtlmn">
                                                            <img src={locationIcon} className="contactIcon" />
                                                            {data?.address && `${data?.address}, `}
                                                            {data?.location && `${data?.location}, `}
                                                            {data?.emirate && `${data?.emirate}, `}
                                                            {data?.countryName}
                                                        </span>
                                                    </div>

                                                    <div className="getdrctnBtnDiv d-flex justify-content-between divloctin">
                                                        <a
                                                            href={data?.locationLink}
                                                            className="getdirectionbtn"
                                                            target="_blank"
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            Get Direction
                                                            <i className="fa-solid fa-diamond-turn-right"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        <div className="abtbrsdr">
                                            <div className="flxcntnt">
                                                <p className="cntncttxt">About Us
                                                    {UserProfileID?.userName === data?.userName &&
                                                        <div className="editeiconimg"
                                                            style={{
                                                                float: "right",
                                                                maxWidth: "25px",
                                                                height: "25px",
                                                                cursor: "pointer",
                                                                marginLeft: "10px",
                                                            }}
                                                            onClick={handleMemberAboutUsModalClick}
                                                        >
                                                            <img src={editicon} alt="edit icon" />
                                                        </div>


                                                    }
                                                </p>
                                                <div className="ArrwiconDiv" onClick={handleaboutClick}>
                                                    <span
                                                        className={
                                                            aboutdetail
                                                                ? "fa-solid fa-chevron-up"
                                                                : "fa-solid fa-chevron-down"
                                                        }
                                                    ></span>
                                                </div>
                                            </div>
                                            {aboutdetail && (
                                                <div className="">
                                                    <p className="txtabtmain text-justify" style={{ whiteSpace: 'pre-wrap' }}>
                                                        {data?.companyDescription}
                                                    </p>
                                                </div>
                                            )}
                                        </div>

                                        {data?.service?.length > 0 && (
                                            <div className="servcbrdr">
                                                <div className="flxcntnt">
                                                    <p className="cntncttxt">Services
                                                        {UserProfileID?.userName === data?.userName &&
                                                            <div className="editeiconimg"
                                                                style={{
                                                                    float: "right",
                                                                    maxWidth: "25px",
                                                                    height: "25px",
                                                                    cursor: "pointer",
                                                                    marginLeft: "10px"
                                                                }}
                                                                onClick={handleAddServiceModalClick}
                                                            >
                                                                <img src={editicon} alt="Edit Icon" title="Edit Icon" />
                                                            </div>
                                                        }
                                                    </p>
                                                    <div className="ArrwiconDiv" onClick={handleserviceClick}>
                                                        <span
                                                            className={
                                                                servicedetail
                                                                    ? "fa-solid fa-chevron-up"
                                                                    : "fa-solid fa-chevron-down"
                                                            }
                                                        ></span>
                                                    </div>
                                                </div>
                                                {servicedetail && (
                                                    <MyProfileServices
                                                        data={data}
                                                        setData={setData}
                                                        setSaveEditedData={setSaveEditedData}
                                                    />
                                                )}

                                            </div>
                                        )}

                                        {data?.productData?.length > 0 && (
                                            <div className="prdrtbrdr">
                                                <div className="flxcntnt">
                                                    <p className="cntncttxt">Products
                                                        {UserProfileID?.userName === data?.userName &&
                                                            <div className="editeiconimg"
                                                                style={{
                                                                    float: "right",
                                                                    maxWidth: "25px",
                                                                    height: "25px",
                                                                    cursor: "pointer",
                                                                    marginLeft: "10px"
                                                                }}
                                                                onClick={handleMemberProductUpdateModalClick}
                                                            >
                                                                <img src={editicon} alt="edit icon" />
                                                            </div>
                                                        }
                                                    </p>
                                                    <div className="ArrwiconDiv" onClick={handleproductClick}>
                                                        <span
                                                            className={
                                                                productdetail
                                                                    ? "fa-solid fa-chevron-up"
                                                                    : "fa-solid fa-chevron-down"
                                                            }
                                                        ></span>
                                                    </div>
                                                </div>
                                                {productdetail && (
                                                    <div className="">
                                                        <div className="prdrtflxdivmain">
                                                            {data?.productData?.map((item, index) => {
                                                                return (
                                                                    <div
                                                                        className="brdrprdctdiv"
                                                                        key={`itemy-${index}`}
                                                                        onClick={() => handlemodalClick(item)}
                                                                    >
                                                                        <div className="prdcgimg">
                                                                            <img src={item?.image} alt="..." />
                                                                        </div>
                                                                        <div className="textparamain">
                                                                            <p className="txtdiv">{item?.name}</p>
                                                                            <p className="txtpara">{item?.description}</p>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        <div className="brdrsrvc">
                                            <div className="flxcntnt">
                                                <p className="cntncttxt"> Video Profile
                                                    {UserProfileID?.userName === data?.userName &&
                                                        <div className="editeiconimg"
                                                            style={{
                                                                float: "right",
                                                                maxWidth: "25px",
                                                                height: "25px",
                                                                cursor: "pointer",
                                                                marginLeft: "10px"
                                                            }}
                                                            onClick={handleMemberVideoUpdateModalClick}
                                                        >
                                                            <img src={editicon} alt="edit icon" />
                                                        </div>
                                                    }
                                                </p>
                                                <div
                                                    className="ArrwiconDiv"
                                                    onClick={handleservicepdfClick}
                                                >
                                                    <span
                                                        className={
                                                            servicepdfdetail
                                                                ? "fa-solid fa-chevron-up"
                                                                : "fa-solid fa-chevron-down"
                                                        }
                                                    ></span>
                                                </div>
                                            </div>
                                            {servicepdfdetail && (
                                                <div>
                                                    {data?.videoUrl && (
                                                        <div className="vdoighh">
                                                            <ReactPlayer
                                                                title="YouTube video player"
                                                                className="ReactPlayerdiv"
                                                                url={data?.videoUrl}
                                                                onPlay={() => addRewardPoints(data?._id, RewardPoints.PROFILE_VIDEO_TYPE)}
                                                            />
                                                        </div>
                                                    )}

                                                </div>
                                            )}
                                        </div>

                                        <div className="brdrsrvc">
                                            <div className="flxcntnt">
                                                <p className="cntncttxt">PDF Profile
                                                    {UserProfileID?.userName === data?.userName &&
                                                        <div className="editeiconimg"
                                                            style={{
                                                                float: "right",
                                                                maxWidth: "25px",
                                                                height: "25px",
                                                                cursor: "pointer",
                                                                marginLeft: "10px"
                                                            }}
                                                            onClick={handleMemberVideoDocUpdateModalClick}
                                                        >
                                                            <img src={editicon} alt="edit icon" />
                                                        </div>
                                                    }
                                                </p>
                                                <div
                                                    className="ArrwiconDiv"
                                                    onClick={handleservicepdfClick}
                                                >
                                                    <span
                                                        className={
                                                            servicepdfdetail
                                                                ? "fa-solid fa-chevron-up"
                                                                : "fa-solid fa-chevron-down"
                                                        }
                                                    ></span>
                                                </div>
                                            </div>
                                            {servicepdfdetail && (
                                                <div>
                                                    {data?.doc?.length > 0 && (
                                                        <div className="pdrmainflx">
                                                            {data?.doc?.map((item, i) => {
                                                                return (
                                                                    <div className="pdfflxDiv" key={`itemz-${i}`}>
                                                                        <div className="pdfimg">
                                                                            <img src={pdf} alt="..." />
                                                                            <div className="inpuduv">
                                                                                <a href={item?.doc}></a>
                                                                            </div>
                                                                        </div>
                                                                        <div className="prflmainflx">
                                                                            <p className="prfltxtprdct">
                                                                                {item?.docName
                                                                                    ? item.docName
                                                                                    : `Document${i + 1}`}
                                                                            </p>
                                                                            <a
                                                                                href="#"
                                                                                onClick={(e) => handleLinkClick(e, item?.pdf, data?._id, RewardPoints.PDF_DOWNLOAD_TYPE)}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                download=""
                                                                                className=" text-primary mt-2"
                                                                            >
                                                                                Open PDF{" "}
                                                                                <i className="fa-solid fa-download"></i>
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </>
                            )}
                        </>
                    )}
                </div>
                {/* </SkeletonTheme> */}
                {modala && (
                    <ProductViewModal closemodal={setModala} ProductItem={ProductItem} profile={data} />
                )}
                {showmodal && (
                    <QRshareModal
                        closeModal={setShowmodal}
                        Qrimage={data?.qrCode}
                    />
                )}

                {editlogomaodalaa && (
                    <MemberImageEditModal
                        updateForm={updateForm}
                        setUrl={setUrl}
                        url={url || data?.profilePhoto || blankpro}
                        closemodal={setEditlogomaodalaa}
                        setSaveEditedData={setSaveEditedData}
                    />
                )}

                {contactEditModal && (
                    <MemberProfileEditModal
                        data={data}
                        closemodal={handleContactModalClick}
                        updateForm={updateForm}
                        setData={setData}
                        setSaveEditedData={setSaveEditedData}
                    />
                )}

                {ShareModalOpenClose && (
                    <ProfileShare
                        whatsApp={data?.whatsappNo}
                        linkedInLink={data?.linkedInLink}
                        facebookLink={data?.facebookLink}
                        userLink={data?.userLink}
                        instaLink={data?.instaLink}
                        emailId={data?.emailId}
                    // closeModal={setSharemodal}
                    />
                )}

                {giveratting && (
                    <GiveRattingModal
                        closemodal={setGiveratting}
                        UserID={data?._id}
                    />
                )}

                {companyInfoUpdateModal && (
                    <CompanyInfoUpdateModal
                        data={data}
                        closemodal={handleCompanyInfoUpdateModalClick}
                        updateForm={updateForm}
                        setData={setData}
                        setSaveEditedData={setSaveEditedData}
                    />
                )}

                {memberInfoUpdateModal && (
                    <MemberInfoUpdateModal
                        data={data}
                        closemodal={handleMemberInfoUpdateModalClick}
                        updateForm={updateForm}
                        setData={setData}
                        setSaveEditedData={setSaveEditedData}
                    />
                )}

                {showEditBannerModal && (
                    <MemberBannerProfileUpdate
                        url={url || data?.banner}
                        setUrl={setUrl}
                        updateForm={updateForm}
                        closemodal={setShowEditBannerModal}
                        setIsUpdate={setSaveEditedData}
                    />
                )}

                {memberVideoDocModal && (
                    <MemberVideoDocumentUpdateModal
                        data={data}
                        closemodal={handleMemberVideoDocUpdateModalClick}
                        updateForm={updateForm}
                        setData={setData}
                        setSaveEditedData={setSaveEditedData}
                    />
                )}

                 {memberVideoModal && (
                    <MemberVideoUpdateModal
                        data={data}
                        closemodal={handleMemberVideoUpdateModalClick}
                        updateForm={updateForm}
                        setData={setData}
                        setSaveEditedData={setSaveEditedData}
                    />
                )}

                {memberProductsModal && (
                    <MemberProductsUpdateModal
                        data={data}
                        closemodal={handleMemberProductUpdateModalClick}
                        updateForm={updateForm}
                        setData={setData}
                        setSaveEditedData={setSaveEditedData}
                    />
                )}

                {memberAboutUsModal && (
                    <MyProfileAboutModal
                        data={data}
                        closemodal={handleMemberAboutUsModalClick}
                        updateForm={updateForm}
                        setData={setData}
                        setSaveEditedData={setSaveEditedData}
                    />
                )}
                {addMemberServicesModal && (
                    <AddMyProfileServiceModal
                        closemodal={handleAddServiceModalClick}
                        data={data}
                        setData={setData}
                        updateForm={updateForm}
                        setSaveEditedData={setSaveEditedData}
                    />
                )}

            </div>
        </>
    );
};

export default MemberProfile;
